/** Display projection only: these lists never become access rules or download materials. */
export const learningExtraTypes = ['learning_materials', 'requirements', 'company_logos'];

export function learningExtras(value = {}) {
  return Object.fromEntries(learningExtraTypes.map(kind => [kind, Array.isArray(value?.[kind]) ? value[kind].map(row => kind === 'company_logos'
    ? { reference_id: String(row?.reference_id ?? '') } : { value: String(row?.value ?? '') }) : []]));
}

export function learningExtraPayload(raw) {
  return Object.fromEntries(learningExtraTypes.map(kind => [kind, raw.getAll(`extra_${kind}`).map(value => kind === 'company_logos'
    ? { reference_id: String(value) } : { value: String(value) })]));
}

export function learningLogoOptions(config, courseId, assetId, imageAlt) {
  if (!Number.isSafeInteger(Number(courseId)) || Number(courseId) < 1 || !/^[1-9][0-9]*$/.test(String(assetId)) || !Number.isSafeInteger(Number(assetId))) return null;
  return { ...config, assetId: Number(assetId), context: { kind: 'course_logo', course_id: Number(courseId), entity_id: Number(courseId) }, imageAlt, cover: true };
}
